import { render, staticRenderFns } from "./importTask.vue?vue&type=template&id=b09a09c8&scoped=true"
import script from "./importTask.vue?vue&type=script&lang=js"
export * from "./importTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b09a09c8",
  null
  
)

export default component.exports